// components/admin/AdminTopbar.jsx
// Mirrors the KFX topbar — uses exact same CSS classes from global.css
// ✅ Mobile: hamburger shows, date hides on tiny screens, breadcrumb truncates

import { useState, useEffect } from 'react';

const PAGE_TITLES = {
  overview:  'Overview',
  paid:      'Paid Users',
  locations: 'User Locations',
  devices:   'Device Analytics',
  referrals: 'Referral Program',
  settings:  'Settings',
};

export default function AdminTopbar({ page, onHamburger }) {
  const [time, setTime] = useState('');
  const [date, setDate] = useState('');

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      setTime(now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }));
      setDate(now.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }));
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="topbar">
      <div className="topbar-left">
        {/* Hamburger — visible on mobile only via CSS (.hamburger { display:none } → display:flex at ≤960px) */}
        <button className="hamburger" onClick={onHamburger} aria-label="Open menu">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6"  x2="21" y2="6"/>
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </button>

        <div className="topbar-meta">
          {/* Breadcrumb — hidden on very small screens via .tb-breadcrumb-hide */}
          <div className="topbar-breadcrumb tb-breadcrumb-hide">
            <span className="tb-crumb-root">KFX Admin</span>
            <span className="tb-crumb-sep">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </span>
            <span className="tb-crumb-cur">{PAGE_TITLES[page] || page}</span>
          </div>
          <div className="topbar-title topbar-title-truncate">{PAGE_TITLES[page] || page}</div>
        </div>
      </div>

      <div className="topbar-right">
        {/* Live status */}
        <div className="topbar-status">
          <span className="live-dot"/>
          <span className="live-text">Live</span>
        </div>

        {/* Date + time — date text hidden on narrow screens via global.css (.topbar-date { display:none } at ≤960px) */}
        <div className="topbar-datetime">
          <svg className="tb-cal-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <rect x="3" y="4" width="18" height="18" rx="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8"  y1="2" x2="8"  y2="6"/>
            <line x1="3"  y1="10" x2="21" y2="10"/>
          </svg>
          <span className="topbar-date">{date}</span>
          <span className="topbar-time">{time}</span>
        </div>
      </div>
    </div>
  );
}